<template>
  <div>
    <div>
      <v-container>
        <v-row justify="center">
          <v-col md="8">
            <trackBookings
                class="mb-6"
                v-for="(booking, i) of bookings"
                :key="i"
                :booking="booking"
                :position="position"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import trackBookings from '@/components/bookings/client/trackBookings';

export default {
  name: 'clientMaps',
  components: {
    trackBookings
  },
  data(){
    return{
      position: {}
    }
  },
  computed: {
    bookings() {
      return this.$store.getters.getTrackBookings;
    },
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  watch: {
    bookings(bookings) {
      if (bookings.length < 1) {
        alert('No track pending bookings yet');
        this.$router.push('/dashboard/bookings');
      }
      else{
        bookings.forEach((booking) => {
          if(booking.driver){
            this.position = {
              lat: Number.parseFloat(booking.driver.lat),
              lng: Number.parseFloat(booking.driver.long)
            };
          }
          else{
            this.position = {
              lat: Number.parseFloat(booking.lat),
              lng: Number.parseFloat(booking.long)
            };
          }
        })
      }
    }
  },
  mounted() {
    if (this.bookings.length === 0){
      this.$store.dispatch('trackBookings', this.user.id);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>